import React from 'react';
import ModalFull from 'components/Tvendo/Common/ModalFull';
import ReactTable from 'components/ReactTable/ReactTable';

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 130 },
  { Header: 'Código', accessor: 'ItemCode' },
  { Header: 'Producto', accessor: 'ItemName' },
  { Header: 'Precio unitario', accessor: 'unit_price', width: 200 },
  { Header: 'Precio paquete', accessor: 'package_price', width: 200 },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

function DifferenceListPricesModal(props) {
  const { priceList, toList, setDifferenceList, differencePrices, setDifferencePrices } = props;

  return (
    <ModalFull
      title={`Diferencia ${priceList.ListName} => ${toList.ListName}`}
      open={differencePrices.length > 0}
      setOpen={() => {
        setDifferencePrices([]);
        setDifferenceList({});
      }}
    >
      <ReactTable
        defaultWidth={1100}
        exportExcel={true}
        columns={columns}
        data={differencePrices.map((item, i) => {
          return {
            num: i + 1,
            ItemCode: item.product.ItemCode,
            ItemName: item.product.ItemName,
            unit_price: `S/ ${parseFloat(item.unit_price).toFixed(2)}`,
            package_price: `S/ ${parseFloat(item.package_price).toFixed(2)}`,
            actions: '',
          };
        })}
      />
    </ModalFull>
  );
}

export default DifferenceListPricesModal;
